import { render, staticRenderFns } from "./PhoneListEditor.vue?vue&type=template&id=4317c539&"
import script from "./PhoneListEditor.vue?vue&type=script&lang=js&"
export * from "./PhoneListEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports